import { ReactElement } from 'react';
import { Form, FormItemProps } from 'antd';

export function FormItem<T>({ rules, label, ...props }: FormItemProps<T>): ReactElement {
    const isRequired = rules?.some((rule) => 'required' in rule && rule.required);

    return <Form.Item<T> rules={rules} label={isRequired ? `${label}*` : label} {...props} />;
}
